var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSucccessPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7474 9.99935L9.2474 12.4993L14.2474 7.49935M18.8307 9.99935C18.8307 14.6017 15.0998 18.3327 10.4974 18.3327C5.89502 18.3327 2.16406 14.6017 2.16406 9.99935C2.16406 5.39698 5.89502 1.66602 10.4974 1.66602C15.0998 1.66602 18.8307 5.39698 18.8307 9.99935Z",
    stroke: "#17B26A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucccessPayment);
export default __webpack_public_path__ + "static/media/succcessPayment.8b744672be6982654d059a56579116e0.svg";
export { ForwardRef as ReactComponent };